$(document).on('ready', function (){
    $("#report").on('click', function() {
        sendReport();
        $("#report").hide();
        $("#report-confirmation").show();
    });
});


function sendReport() {
    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });
    $.ajax({
        url: "/report",
        method: 'post',
        data: {
            location: window.location.href
        },
        success: function(result){
        }
    });
}